import { render, staticRenderFns } from "./ComplaintReport.vue?vue&type=template&id=40a72a57&scoped=true"
import script from "./ComplaintReport.vue?vue&type=script&lang=js"
export * from "./ComplaintReport.vue?vue&type=script&lang=js"
import style0 from "./ComplaintReport.vue?vue&type=style&index=0&id=40a72a57&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./ComplaintReport.vue?vue&type=style&index=1&id=40a72a57&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a72a57",
  null
  
)

export default component.exports